<ng-container *transloco="let t; read: 'user'">
<div>
    <div class="flex flex-row">
        <div>
            <h2 class="mb-2 mt-0 text-3xl leading-tight">{{ t('dashboard.portfolio.portfolioClass.viewingChildrenIn') }} <b>{{classroomName}}</b></h2>
            <h2 class="mb-2 mt-0 text-2xl leading-tight">{{ t('dashboard.portfolio.ratingPeriodLabel') }} <b>{{ratingPeriodName}}</b></h2>
        </div>
    </div>
    <drdp-container>
        <div class="p-5 w-full">
            <drdp-add-edit-table (toggleSwitchActionItem)="handleSelectedChild($event)"
                                 (viewActionItem)="reviewEvidence($event)"
                                  viewIcon="uil uil-notes text-drdpblue-300"
                                  [dataSource]="dataSource"
                                  [tableData]="tableData"
                                  [columns]="tableColumns">
            </drdp-add-edit-table>
        </div>

        <div class="border border-drdpred-200 rounded">
            <p class="text-drdpred-200 p-2">
                {{ t('dashboard.portfolio.portfolioClass.ageGradeWarning') }}
            </p>
        </div>
        <div *drdpCheckPermission="permission.EditObservations" class="mt-10 mb-2 flex justify-end">
            <drdp-btn class="pr-4" color="cancel" type="button" (click)="onCancel()">
                {{ t('dashboard.portfolio.actions.cancel') }}
            </drdp-btn>
            <drdp-btn type="submit" (click)="onNextButton()" cdkFocusInitial>
                {{ t('dashboard.portfolio.actions.next') }}
            </drdp-btn>
        </div>

    </drdp-container>

</div>
<mat-paginator class="pb-6" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalData" [pageIndex]="pageIndex"
    (page)="paginateTable($event)">
</mat-paginator>
</ng-container>
